import { Icon } from "metabase/ui";
import { isReducedMotionPreferred } from "metabase/utils/dom";

import { SpinnerIcon, SpinnerRoot } from "./LoadingSpinner.styled";

interface Props {
  className?: string;
  size?: number;
  borderWidth?: number;
  "data-testid"?: string;
}

const BaseLoadingSpinner = ({
  className,
  size = 32,
  borderWidth = 4,
  "data-testid": dataTestId,
}: Props) => (
  <SpinnerRoot
    className={className}
    data-testid={dataTestId ?? "loading-indicator"}
  >
    {isReducedMotionPreferred() ? (
      <Icon name="hourglass" size="24" />
    ) : (
      <SpinnerIcon iconSize={size} borderWidth={borderWidth} />
    )}
  </SpinnerRoot>
);

/**
 * @deprecated: use Loader from "metabase/ui"
 */
export const LoadingSpinner = Object.assign(BaseLoadingSpinner, {
  Root: SpinnerRoot,
});
